package navigation.settings.paymentparameter.addeditpaymentparameter

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.paymentparameter.domain.repository.PaymentParameterRepository
import com.essntl.features.paymentparameter.ui.addeditpaymentparameter.AddEditPaymentParameterEvent
import com.essntl.features.paymentparameter.ui.addeditpaymentparameter.AddEditPaymentParameterState
import com.essntl.features.paymentparameter.ui.addeditpaymentparameter.AddEditPaymentParameterValidation
import com.essntl.features.paymentparameter.ui.addeditpaymentparameter.AddEditPaymentParameterViewModel
import com.essntl.toastmanager.ToastManager

class AddEditPaymentParameterScreenModel(
    paymentParameterRepository: PaymentParameterRepository,
    toastManager: ToastManager,
    loadingManager: LoadingManager,
) : StateScreenModel<AddEditPaymentParameterState>(AddEditPaymentParameterState()) {
    val validation = AddEditPaymentParameterValidation()

    private val addEditPaymentParameterViewModel =
        AddEditPaymentParameterViewModel(
            paymentParameterRepository = paymentParameterRepository,
            toastManager = toastManager,
            state = mutableState,
            scope = screenModelScope,
            loadingManager = loadingManager,
        )

    fun onEvent(event: AddEditPaymentParameterEvent) {
        addEditPaymentParameterViewModel.onEvent(event)
    }
}